import ltrStyles from "./design.scss?inline";
import rtlStyles from "./design.scss?inline&rtl";

const STYLE_ID = "pm-design";

export function applyStylesheet(direction: "ltr" | "rtl") {
    let node = document.getElementById(STYLE_ID) as HTMLStyleElement | null;
    if (!node) {
        node = document.createElement("style");
        node.id = STYLE_ID;
        document.head.appendChild(node);
    }
    const css = direction === "rtl" ? rtlStyles : ltrStyles;
    if (node.dataset.direction !== direction) {
        node.textContent = css;
        node.dataset.direction = direction;
    }
}
